module.exports = __webpack_public_path__ + "static/media/googleAssistantCookie.92b7a543.gif";